import { Model } from 'modules/core/lib/mobx-rest'

interface IApprovalGroupMembership {
  id: number
  access_id: number
  approval_group_id: number
}

export type Categories = 'contracts'

class ApprovalGroupMembership extends Model<IApprovalGroupMembership> {
  static urlRoot() {
    return '/approvals/approval_group_memberships'
  }

  constructor(attr: IApprovalGroupMembership) {
    super(attr)
  }
}

export default ApprovalGroupMembership
